export default {
  //VERSION
  "VERSION": "1.0.0",//VERSION PLATTFORM
  // MAIN VARIABLES
  "BASE_ENDPOINT_LOCAL": "https://gogodev.net/avemarian/api",  //BASE ENDPOINT LOCAL 
  "BASE_ENDPOINT": "https://gogodev.net/avemaria/api", // BACKEND BASE ENDPOINT URI
  "FILES_CDN_READ": "https://gogodev.net/avemaria-cdn/", 
  "NAME_PLATFORM": "Ave Maria Formación",//NAME PLATFORM HEADER
  "LOGO_URI": "../../icons/color.png", // RELATIVE LOGO URI
  "LOGO_WIDTH": "120", // TOP BAR LOGO WIDTH IN PIXELS OR PERCENTAGE (Ex. 120 or 100%)
  "LOGO_FOOTER_URI": "../../icons/white.png", // RELATIVE LOGO URI (WHITE VERSION)
  "LOGO_SMALL": "../../icons/color.png", // RELATIVE SMALL LOGO (USUALLY THE IMAGO, FOR MOBILE DEVICES)
  "SCHOOL_URL": "https://escuelasavemaria.com/",// SCHOOL URL FOR PROMOTION AND ABOUT SECTION
  "INIT_URL": "https://escuelasavemaria.com/",// URL CAMPUS INIT
  //"PORTFOLIO_LINK": "https://ademass.com", // BASE LINK FOR PORTFOLIO QR
  //"PORTFOLIO_PRINT_LINK": "https://campus-ademass.com/portfolio2", // URL PORTFOLIO PRINTABLE VERSION
  "NAME_COMPANY_FOOTER": "Escuelas Ave María", // COMPANY NAME FOR FOOTER
  "NAME_COMPLETE_COMPANY": "Escuelas Ave María ", // LEGAL COMPANY NAME
  "NAME_STREET": "Av. Sor Teresa Prat 51", // COMPANY ADDRESS
  "POSTAL_CODE": "29003", // ZIP CODE
  "COMPANY_CITY": "España | Málaga", // LOCATION
  "PRIVACY_POLICY": "https://escuelasavemaria.com/politica-privacidad/", // PRIVACY POLICY URI
  "TERMS_OF_USE": "/pdf/terminos.pdf", // TERMS OF USE URI
  "LEGAL_NOTICE": "https://escuelasavemaria.com/politica-privacidad/", // LEGAL NOTICE URI
  "COOKIE_POLICY": "https://escuelasavemaria.com/politica-de-cookies/", // COOKIE POLICY URI
   "EMAIL_INFO": "", // INFO EMAIL 
   "EMAIL_SUPPORT": "", // SUPPORT EMAIL
   "EMAIL_RECRUITMENT": "", // RECRUITMENT EMAIL
   "EMAIL_BUSINESS": "", // BUSINESS EMAIL
  "EMAIL_ADMINISTRATION": "secretaria@escuelasavemaria.com", // ADMINISTRATION EMAIL
  "SECONDARY_COLOR": "#11165B",//SECONDARY COLOR
  "THIRD_COLOR": "#38B6FF",//THIRD COLOR
  "TEXT_CARD_NEWS": "Mantente informado, aquí encontrarás las últimas novedades y tendencias en el ámbito educativo. Actualizaciones diarias para impulsar tu conocimiento.",
  "TEXT_CENTER": "Visita aquí nuestra página web y conoce escuelas Ave María, uno de los centros educativos con más historia de Málaga Capital.",
  "ROADMAP_CARD_MAIN_TEXT": "Deja de picotear cursos sin orden. Tú tan solo dinos qué quieres saber, y nosotros te ordenamos el contenido para que logres tu objetivo.",//TEXT ITEM CARD MAIN ROADMAP,
  "COURSE_CARD_MAIN_TEXT": "Si tienes claro que es lo que buscas, ve directamente a por ello. Selecciona el curso que deses y conviértete en un experto en aquello que anhelas.",//TEXT ITEM CARD MAIN COURSE
  "CERTIFICATIONS_CARD_MAIN_TEXT": "¿Has terminado ya el curso? ¡Es hora de demostrar lo que sabes! Busca su certificación y pasa el examen para obtener tu diploma acreditativo.",//TEXT ITEM CARD MAIN CERTIFICATIONS
  "EMPLOY_CARD_MAIN_TEXT": "¿Buscas empleo? Ya sea porque estás buscando nuevas oportunidades, o porque quieres continuar progresando. ¡Echa un vistazo a nuestras ofertas!",//TEXT ITEM CARD MAIN EMPLOY
  "FORUM_CARD_MAIN_TEXT": "¿Tienes alguna duda? ¡Accede al foro y compártela con la comunidad. Entre todos te ayudaremos a solucionarla. Compartir es aprender.",//TEXT ITEM CARD MAIN FORUM
  "SOCIAL_NETWORK_CARD_MAIN_TEXT": "Sigue a los miembros de la comunidad y comparte información de calidad sobre tu aprendizaje. Como cualquier red social, pero sin gente bailando. Solo formación.",//TEXT ITEM CARD MAIN SOCIAL_NETWORK
  "SUPPORT_CARD_MAIN_TEXT": "En Ave María estamos comprometidos con la formación de calidad, por ello si tienes alguna sugerencia o duda, estamos aqui para escucharte.",//TEXT ITEM CARD MAIN SUPPORT
  "FAQS_CARD_MAIN_TEXT": "¿Tienes alguna duda  sobre los servicios de escuelas Ave María, o nuestra escuela en general? Consulta nuestras preguntas frecuentes.",//TEXT ITEM CARD MAIN SUPPORT
  "TITLE_BUTTON_FOLLOW_ROADMAP_WIDGET_BEFORE": "Seguir",//TEXT TITLE BUTTON FOLLOW ROADMAP BEFORE PUSH
  "TITLE_BUTTON_FOLLOW_ROADMAP_WIDGET": "Siguiendo",//TEXT TITLE BUTTON FOLLOW ROADMAP AFTER PUSH
  "TITLE_BUTTON_FOLLOW_COURSE_WIDGET_BEFORE": "Seguir",//TEXT TITLE BUTTON FOLLOW COURSE AFTER PUSH
  "TITLE_BUTTON_FOLLOW_COURSE_WIDGET": "Siguiendo",//TEXT TITLE BUTTON FOLLOW COURSE AFTER PUSH

  //VIEW ACTIVITYQUESTIONS TITLES TABLE(TH)
  "TH_1_ACTIVITY_VIEW": "Nº de Ejercicio",//TH 1 ATIVITYQUESTIONVIEW
  "TH_2_ACTIVITY_VIEW": "Enunciado",//TH 2 ATIVITYQUESTIONVIEW
  "TH_3_ACTIVITY_VIEW": "Ver respuestas",//TH 3 ATIVITYQUESTIONVIEW

  //VIEW ACTIVITY TITLES TABLE(TH)
  "TH_1_ACTIVITY_COURSE_VIEW": "Itinerario Formativo",//TH 1 ATIVITYVIEW
  "TH_2_ACTIVITY_COURSE_VIEW": "Curso Formativo",//TH 2 ATIVITYVIEW
  "TH_3_ACTIVITY_COURSE_VIEW": "Fecha de publicación",//TH 3 ATIVITYVIEW
  "TH_4_ACTIVITY_COURSE_VIEW": "Ver ejercicios",//TH 3 ATIVITYVIEW

  //VIEW CANDIDATURE TITLES TABLE(TH)
  "TH_1_CANDIDATURE": "Puesto",//TH 1 CANDIDATURE
  "TH_2_CANDIDATURE": "País/Ciudad",//TH 2 CANDIDATURE
  "TH_3_CANDIDATURE": "Modalidad",//TH 3 CANDIDATURE
  "TH_4_CANDIDATURE": "Salario",//TH 4 CANDIDATURE
  "TH_5_CANDIDATURE": "Estado",//TH 5 CANDIDATURE
  "TH_6_CANDIDATURE": "Ver detalles",//TH 6 CANDIDATURE

  //FORUM GENERAL VIEW
  "TITLE_FORUM_GENERAL_VIEW": "Selecciona el tema",//TITLE SECTION 
  "SUBTITLE_FORUM_GENERAL_VIEW": "¡Importante! selecciona el tema sobre el que quieres realizar una pregunta general. Recuerda que para preguntas sobre un curso concreto tienes la sección de 'Cursos'.",//TITLE SECTION 

  //HALLOFFAME VIEW
  "TITLE_HALL_OF_FAME": "Salón de la Fama",//TITLE VIEW HALL OF FAME 
  "SUBTITLE_HALL_OF_FAME": "Top 10 Usuarios Con Mayor Reputación",//SUBTITLE VIEW HALL OF FAME 
  "TH_1_HALL_OF_FAME": "Imagen",//TH 1 HALLOFFAME
  "TH_2_HALL_OF_FAME": "Nombre (Reputación)",//TH 2 HALLOFFAME
  "TH_3_HALL_OF_FAME": "Acciones",//TH 3 HALLOFFAME

  //JOBOFFERINGVIEW
  "TITLE_OFFERINGVIEW": "Ofertas de Empleo Activas",//TITLE JOBOFFERINGVIEW 
  "TH_1_OFFERINGVIEW": "Puesto",//TH 1 OFFERINGVIEW
  "TH_2_OFFERINGVIEW": "País/Ciudad",//TH 2 OFFERINGVIEW
  "TH_3_OFFERINGVIEW": "Modalidad",//TH 3 OFFERINGVIEW
  "TH_4_OFFERINGVIEW": "Salario",//TH 4 OFFERINGVIEW
  "TH_5_OFFERINGVIEW": "Ver detalles",//TH 5 OFFERINGVIEW

  //NEWSVIEW
  "TITLE_NEWS": "Noticias Escuelas Ave María",//TITLE NEWS ,
  "TH_1_NEWS": "Noticia",//TH 1 NEWS
  "TH_2_NEWS": "Ver detalles",//TH 2 NEWS
  //MYQUESTIONVIEW
  "TH_1_QUESTION_VIEW": "Resuelta",//TH 1 QUESTION
  "TH_2_QUESTION_VIEW": "Pregunta",//TH 2 QUESTION
  "TH_3_QUESTION_VIEW": "Fecha",//TH 3 QUESTION
  "TH_4_QUESTION_VIEW": "Seleccionar",//TH 3 QUESTION

  //MYROADMAPSVIEW
  "TITLE_ROADMAP_VIEW": "Mis Itinerarios Formativos",//TITLE MYROADMAP VIEW

  //PDFVIEW
  "TITLE_PDFVIEW": "¡Bienvenido a nuestra sección de Manuales!",//TITLE VIEW PDFVIEW
  "SUBTITLE_PDFVIEW": " En esta sección podréis ir descargando las guías y manuales de tu curso favorito.",//SUBTITLE VIEW PDFVIEW
  "TH_1_PDFVIEW": "Curso",//TH 1 PDFVIEW
  "TH_2_PDFVIEW": "Autor",//TH 2 PDFVIEW
  "TH_3_PDFVIEW": "Descargar PDF",//TH 3 PDFVIEW

  //PROJECT OFFERINGVIEW
  "TITLE_PROJECT_OFFERINGVIEW": "Ofertas de Prácticas en empresa",//TITLE VIEW PROJECTOFFERING
  "TEXT_REMEMBER": "¡¡¡Importante!!! Recuerda cumplimentar tu perfil de empleo para poder optar a los puestos ofertados.", //TEXT REMEMBER TO FILL IN THE PROFILE
  "TH_1_PROJECT_OFFERINGVIEW": "Empresa / Puesto",//TH 1 PROJECT OFFERING VIEW
  "TH_2_PROJECT_OFFERINGVIEW": "Perfil",//TH 2 PROJECT OFFERING VIEW
  "TH_3_PROJECT_OFFERINGVIEW": "Modalidad",//TH 3 PROJECT OFFERING VIEW
  "TH_4_PROJECT_OFFERINGVIEW": "Plazas",//TH 4 PROJECT OFFERING VIEW
  "TH_5_PROJECT_OFFERINGVIEW": "Ver detalles",//TH 5 PROJECT OFFERING VIEW

  //REPUTATIONVIEW
  "TITLE_REPUTATIONVIEW": "Mi Reputación",//TITLE REPUTATION VIEW
  "SUBTITLE_REPUTATIONVIEW": "Cómo Obtener Puntos",//SUBTITLE REPUTATION VIEW
  "TEXT_DEFINITION_1": "Los puntos de reputación  se obtienen alcanzando metas en la plataforma.",//FIRST PARAGRAPH EXPLAINING THE POINTS
  "TEXT_DEFINITION_2": "  Algunas de las acciones puntuadas son la obtención de nuevos certificados, responder preguntas que obtienen el apoyo de los compañeros o que son marcadas como respuesta correcta por su autor, escribir y difundir Posts que gustan a los demás usuarios, indicar qué respuesta a solucionado una duda a una pregunta tuya, completar tu perfil de empleo...",//SECOND PARAGRAPH EXPLAINING THE POINTS
  "TEXT_DEFINITION_3": "En definitiva: Se participativo, ayuda a los demás, comparte información de interés para todos, consigue tus metas de estudio, y la plataforma te recompensará. En esta sección podrás ver un desglose de todos los puntos obtenidos y su porqué.",//THIRD PARAGRAPH EXPLAINING THE POINTS
  "TEXT_DEFINITION_4": "¿Para qué sirven los puntos de reputación ?",//FOURTH PARAGRAPH EXPLAINING THE POINTS
  "TEXT_DEFINITION_5": "Los puntos de reputación te ayudarán a posicionarte mejor en ofertas de empleo a las que te presentes con respecto a candidatos que cumplan el mismo perfil que tú. Además, desde la comunidad trabajamos a diario para ampliar los beneficios que estos aportan. ¡Tu reputación te ayuda a destacar!",//FIFTH PARAGRAPH EXPLAINING THE POINTS


  //IMAGES
  "NEWS_CARD_IMG": "/img/photos/news.jpg",  //IMG NEWS AVE MARIA CARD
  "NEWS_CARD_SCHOOL_IMG": "/img/photos/school.jpg",
  "BOOK_SHOP_IMG": "/img/lms/backend.png", //IMG BOOK DETAIL
  "POST_IMG": "/img/lms/fullstack.jpg",//IMG CODEPOSTWRITE COMPONENT
  "QUESTION_COURSES": "/img/photos/courses.jpg",//IMG ITEM CARD QUESTION COURSES
  "QUESTION_COURSES_GENERAL": "/img/photos/courses.jpg",//IMG ITEM CARD QUESTION COURSES GENERAL
  "NEW_QUESTION_COURSE": "/img/lms/fullstack.jpg",//IMG NEW QUESTION 
  "RESPONSE_QUESTION_COURSE": "/img/lms/frontend.jpg",//IMG NEW QUESTION 
  "RESPONSE_GENERAL_LIST": "/img/lms/machine.png",//RESPONSE FORUMGENERALLISTVIEW AND FORUMDETAILVIEW
  "QUESTION_SEND": "/img/lms/fullstack.jpg", //QUESTION SEND IMG
  "ANSWERVIEW_IMG": "/img/lms/devops.jpg", //ANSWER VIEW IMG THANKS
  "SHOP_DETAIL_VIEW": "/img/lms/backend.png",  //SHOP DETAIL PRODUCT
  "CODE_BITE_WRITE": "/img/lms/fullstack.jpg",//CODE BITE WRITE IMG
  //IMAGES ITEM CARD
  "ROUTE_SHEETS_IMG": "/img/photos/roadmap.jpg", //ITEM CARD IMG ROUTE SHEETS IMG
  "COURSE_ITEM_IMG": "/img/photos/courses.jpg", //ITEM CARD IMG COURSE IMG
  "CERTIFICATIONS_ITEM_IMG": "/img/photos/certificate.jpg", //ITEM CARD IMG CERTIFICATION IMG
  "JOB_ITEM_IMG": "/img/photos/jobs.jpg", //ITEM CARD IMG JOB IMG
  "FORUM_ITEM_IMG": "/img/photos/forum.jpg", //ITEM CARD IMG FORUM IMG
  "SOCIAL_ITEM_IMG": "/img/photos/social.jpg", //ITEM CARD IMG SOCIAL IMG
  "FRIENDS_ITEM_IMG": "/img/photos/friends.jpg", //ITEM CARD IMG FRIENDS IMG
  "SUPPORT_ITEM_IMG": "/img/photos/support.jpg",//ITEM CARD IMG SUPPORT IMG
  "FAQS_ITEM_IMG": "/img/photos/faqs.jpg",//ITEM CARD IMG SUPPORT IMG


  //SOCIAL
  "has_social_network_advice": false,// HAS SOCIAL BANNER
  "HAS_FACEBOOK": true,// HAS FACEBOOK
  "HAS_LINKEDIN": false,//HAS LINKEDIN
  "HAS_INSTAGRAM": true,//HAS INSTAGRAM
  "HAS_YOUTUBE": true, //HAS YOUTUBE
  "HAS_TWITTER": false,//HAS TWITER
  "HAS_TIKTOK": false,//HAS TIKTOK
  "HAS_X": true,//HAS X
  "LINK_FACEBOOK": " https://www.facebook.com/escuelasavemaria/",// LINK FACEBOOK
  "LINK_LINKEDIN": "",//LINK LINKEDIN
  "LINK_INSTAGRAM": "https://www.instagram.com/escuelasavemaria/",//LINK INSTAGRAM
  "LINK_YOUTUBE": "https://www.youtube.com/c/EscuelasAveMariamalaga", //LINK YOUTUBE
  "LINK_TWITTER": "",//LINK TWITER
  "LINK_TIKTOK": "",//LINK TIKTOK
  "LINK_X": "https://x.com/avemariamalaga",//LINK X
  "TEXT_SOCIAL": "En Ave Maria, estamos comprometidos con tu crecimiento profesional y queremos que alcances tus metas en el mundo del desarrollo. Nos enorgullece ofrecer una plataforma de aprendizaje integral. Queremos estar aún más cerca de ti, compartir experiencias, noticias y recursos exclusivos que impulsen tu carrera. ¿Cómo? ¡A través de nuestras redes sociales! 🌐 Por ello, te animamos a seguirnos. Es unaforma genial y gratuita de ayudar a nuestro crecimiento. Nos ayuda mucho, más de lo que pueda parecer. ¡Te loagrademos mucho! Tu éxito es nuestra prioridad, y queremos celebrar cada logro contigo. ¡Construyamos juntos un futurolleno de oportunidades!",//TEXT SOCIAL
  "TITTLE": "Conéctate con el Éxito", //TITLE TEXT

  // MODULE VARIABLES
  "has_module_portfolio":false,//HAS MODULE PORTFOLIO
  "has_module_roadmap": true,//HAS MODULE ROADMAP
  "has_module_employment": false, // HAS EMPLOYMENT MODULE?
  "has_module_questions": true, // HAS QUESTIONS MODULE?
  "has_module_my_questions": true, // HAS QUESTIONS MODULE?
  "has_module_last_questions": true, //HAS MOUDULE LAST QUESTIONS
  "has_module_practice": false, // HAS PRACTICE MODULE?
  "has_module_social": true, // HAS SOCIAL MODULE?
  "has_module_support": true, // HAS SUPPORT MODULE?
  "has_module_forum":true,//HAS MODULE FORUM
  "has_module_faqs": true, // HAS FAQS MODULE?
  "has_module_message": true, // HAS MESSENGER MODULE?
  "has_module_routes": true, // HAS ROUTES MODULE?
  "has_module_certification": true, // HAS CERTIFICATION MODULE?
  "has_module_bootcamp": false, // HAS BOOTCAMP MODULE?
  "has_module_news": true, // HAS NEWS MODULE?
  "has_module_agenda":true,//HAS MODULE AGENDA
  "has_module_challenge": false, // HAS CHALLENGE MODULE?
  "has_module_exercise": false, // HAS EXERCISE MODULE?
  "has_module_webinar": false, // HAS WEBINAR MODULE?
  "has_module_class": true, // // HAS PERSONAL TEACHERS/CLASSES MODULE?
  "has_module_bookshop": true, // HAS CLASS BOOKSHOP?
  "has_module_shop": false, // HAS CLASS SHOP?
  "has_module_my_routes": false,//HAS MODULE MYS ROUTES
  "has_module_communication": true, // HAS FAMILY COMMUNICATION MODULE? ------
  "has_module_roadmap_bar": false,//HAS MODULE ROADMAP_BAR
  "has_module_manual": false,//HAS MODULE MANUAL
  "has_module_course": true,//HAS MODULE COURSE
  "has_module_banner": false, // HAS BANNER MODULE?
  "has_module_banner_prodev": false, // HAS BANNER MODULE?
  "has_module_advertisement": true, // HAS ADVERTISEMENT MODULE?
  "monetization_type": "pay_per_course", // MONETIZATION TYPE (subscription / pay_per_course) // TODO IN COMPONENTS AND VIEWS
  "has_module_discord" : false,// HAS MODULE DISCORD
  //--------------------------------------------------------------------------
  "has_module_fp": true, // HAS FP (OFFCIAL EDUCATION) MODULE?
  "has_module_intranet": true, // HAS INTRANET MODULE?
  "has_module_HR": true, // HAS HUMAN RESOURCES MODULE?
  "module_streaming_platform": "iframe", // STREAMING PLATFORM SUPPORT (youtube / vimeo) // TODO IN COMPONENTS AND VIEWS
  "has_public_registration": true, // EVERYONE CAN REGISTER (PUBLIC), OR REGISTRATION IS PRIVATE // TODO IN COMPONENTS AND VIEWS



  // PAYMENT VARIABLES

  "has_payment_paypal": true, // HAS PAYPAL PAYMENT PLATFORM
  "has_payment_stripe": true, // HAS STRIPE PAYMENT PLATFORM // TODO IN COMPONENTS AND VIEWS
  "has_payment_redsys": true, // HAS REDSYS PAYMENT PLATFORM (VIRTUAL POS) // TODO IN COMPONENTS AND VIEWS
  "PRICE_MONTH": "4,99",// PRICE SUSCRIPTION MONTH
  "PRICE_ANNUAL": "49,90",// PRICE SUSCRIPTION ANNUAL
  "PAYPAL_ID_CLIENT": "AQfjLjOxuhpsNWYSik8beXjqgJOWm-Q9_-V8JfKGdSg_5ow6WT1ZCtSf6KHsGledxGP9vlUEfPb_lO6U",//CLIENT 
  "CLI": "AQfjLjOxuhpsNWYSik8beXjqgJOWm-Q9_-V8JfKGdSg_5ow6WT1ZCtSf6KHsGledxGP9vlUEfPb_lO6U",  // PAYPAL PUBLIC KEY
  "SEC": "ECBegqSFP7l03CSU4cbHKNtHbp2JwcqfJZRJvNJgxldt-YSRZuKIgu4bZofH1MT6Zsk40aVOJ-SYahLl", // PAYPAL SECRET KEY
  "STRIPE_CLI": "AQfjLjOxuhpsNWYSik8beXjqgJOWm-Q9_-V8JfKGdSg_5ow6WT1ZCtSf6KHsGledxGP9vlUEfPb_lO6U",  // STRIPE PUBLIC KEY // TODO IN COMPONENTS AND VIEWS
  "STRIPE_SEC": "ECBegqSFP7l03CSU4cbHKNtHbp2JwcqfJZRJvNJgxldt-YSRZuKIgu4bZofH1MT6Zsk40aVOJ-SYahLl", // STRIPE SECRET KEY // TODO IN COMPONENTS AND VIEWS
  "REDSYS_CLI": "AQfjLjOxuhpsNWYSik8beXjqgJOWm-Q9_-V8JfKGdSg_5ow6WT1ZCtSf6KHsGledxGP9vlUEfPb_lO6U",  // REDSYS PUBLIC KEY // TODO IN COMPONENTS AND VIEWS
  "REDSYS_SEC": "ECBegqSFP7l03CSU4cbHKNtHbp2JwcqfJZRJvNJgxldt-YSRZuKIgu4bZofH1MT6Zsk40aVOJ-SYahLl", // REDSYS SECRET KEY // TODO IN COMPONENTS AND VIEWS
  "PLAN_ID_MONTH": "P-7F343062YS375561DMYB7LWY", //PLAN ID MONTH PAYPAL
  "PLAN_ID_MONTH_NOT_FREE": "P-96L394980W065412PMXOHYLI", //PLAN ID MONTH NOT FREE
  "PLAN_ID_ANUAL": "P-19W68076RC250891AMXOHZ6Q", //PLAN ID MONTH PAYPAL
  "PLAN_ID_ANUAL_NOT_FREE": "P-6N2884890V550730XMYB7OMI", //PLAN ID MONTH NOT FREE
  "WELCOME_MESSAGE": "Bienvenido/a al servicio de  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eligendi officiis consequuntur animi ab totam eum exercitationem labore voluptas voluptatibus nulla? Quia dolorem sed blanditiis vero eveniet odit nihil placeat id!",  //MESSAGE WELCOME TO SUSCRIPTION
}